import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App);

import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faHourglassStart } from "@fortawesome/free-solid-svg-icons";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faPhone);
library.add(faHourglassStart);
library.add(faLock);

app.component("font-awesome-icon", FontAwesomeIcon).mount("#app");
